import { render, staticRenderFns } from "./ProjectPlannerV2.vue?vue&type=template&id=239bfa09&"
import script from "./ProjectPlannerV2.vue?vue&type=script&lang=js&"
export * from "./ProjectPlannerV2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports